/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import { GlobalStore } from "../../store/global/GlobalStore";

export const ReviewOrderHeader: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <div className="row align-items-center">
      <div className="col text-center">
        <p
          className="text-center trade"
          css={css`
            margin-bottom: 1rem;
            font-family: ${theme.fontFamilies["work-sans"]};
            font-size: ${theme.fontSize["6"]};
          `}
        >
          Review Order
        </p>
      </div>
    </div>
  );
};
